const getFormattedDate = (today = new Date())=>{
  let month = today.getMonth()+1 
  month = month < 10 ? '0'+month : month
  let date = today.getDate()
  date = date < 10 ? '0'+date : date
  let hours = today.getHours()
  hours = hours < 10 ? '0'+hours : hours
  let minutes = today.getMinutes()
  minutes = minutes < 10 ? '0'+minutes : minutes
  let seconds = today.getSeconds()
  seconds = seconds < 10 ? '0'+seconds : seconds
  
  return `${hours}:${minutes}:${seconds} ${date}/${month}/${today.getFullYear()}`
}
export default getFormattedDate